//资源类型
export enum RESOURCES_TYPE {
    //子包
    BUNDLE,
    //普通资源
    ASSETS,
    //场景
    SCENE
}

//一次加载数据
export interface oneSonLoadProgress {
    //资源类型
    resourcesType: RESOURCES_TYPE;
    //资源目录或者场景名字
    resPathOrName: string;
    //加载使用文本
    loadText: string;
    //对应bundle 动态加入
    bundle?: () => cc.AssetManager.Bundle;
    //加载完子包回调
    onBundleLoaded?: (bundle: cc.AssetManager.Bundle) => void;
    //加载完资源回调
    onComplete?: (error: Error, assets: cc.Asset[] | cc.Asset) => void;
}